import { Chip } from "@mui/material";
import { TalentSkillDto } from "../api/models/talent";
import ChipContainer from "./TalentChipContainer";

export type TalentSkillChipsProps = {
    skills: TalentSkillDto[],
    removeSkill: (skillId: string) => void,
    isRemovingSkill: boolean
}

const TalentSkillChips = ({
    skills,
    removeSkill,
    isRemovingSkill,
}: TalentSkillChipsProps) => {
    if (isRemovingSkill) return (
        <p className="mt-2">Loading...</p>
    );

    return (
        <ChipContainer className="pt-6">
            {skills
                .sort((a, b) => (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()))
                .map(talentSkill => (
                    <Chip
                        key={`talent-skill-${talentSkill.skillId}`}
                        label={talentSkill.skillName}
                        onDelete={() => removeSkill(talentSkill.skillId)} 
                        variant="outlined"
                        color="secondary"
                        sx={{ marginRight: 1, marginBottom: 1 }}
                    />
                    
                ))

            }
        </ChipContainer>
    );
};

export default TalentSkillChips;